import { Ref, ref } from "vue"
const emailSentTo: Ref<string> = ref("")

export default emailSentTo
